import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=578f3c6e&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=578f3c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f3c6e",
  null
  
)

export default component.exports